function Footer() {
  return (
    <footer className="bg-neutral-950 text-neutral-400 text-center py-6 px-4 font-poppins border-t border-neutral-900">
      <p className="text-xs md:text-sm font-bold tracking-wide leading-relaxed">
        &copy; {new Date().getFullYear()} Universal Goodlife Ashram. All rights reserved.
      </p>
    </footer>
  );
}

export default Footer;